import { Injectable } from "@angular/core";
import { CVApiService } from "src/app/reusables/services/cv-api.service";
import { ModuleManagerExportFormat } from "src/shared/models/module-manager/module-manager-options.model";
import { CxoneGaugeModuleData } from "./cxone-gauge.models";

@Injectable({
    providedIn: "root",
})
export class GaugeService {
  
    constructor(private cvApiService: CVApiService) {}
    public async loadGaugeData(moduleKey: string,abort?: Promise<void>): Promise<CxoneGaugeModuleData> {
        try {
            const moduleRenderURL = await this.cvApiService.getModuleRenderEndPoint(moduleKey);
            const url = `/api/v2/dashboards/modules/gauge/${moduleKey}`;
            const response = await this.cvApiService.get<CxoneGaugeModuleData>(url, moduleRenderURL,abort);
            if (response.status_code >= 200 && response.status_code < 300)
                return response.data;
            else throw response;
        }
        catch (err) {
            console.error("Failed getting module render endpoint");
            throw err;
        }
    }

    async LoadDataForExport(moduleKey: string, format: ModuleManagerExportFormat): Promise<any> {        
        try {
            const moduleRenderURL = await this.cvApiService.getModuleRenderEndPoint(moduleKey);

            const queryString = `/export?format=${format}`;
            const url = `/api/v2/dashboards/modules/gauge/${moduleKey}${queryString}`;

            const response = await this.cvApiService.get<string>(url, moduleRenderURL);
            if (response.status_code >= 200 && response.status_code < 300)
                return response;
            else throw response;
        }
        catch (err) {
            console.error("Failed to get Gauge export data");
            throw err;
        }
    }
}

